export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    perfil_id: [1, 2, 3, 4, 5, 6, 7],
  },
  // {
  //   title: 'Painel Administrativo',
  //   route: 'painel-admin',
  //   icon: 'ActivityIcon',
  //   perfil_id: [5, 7],
  // },
  {
    title: 'Agenda',
    route: 'list-agendamentos',
    icon: 'CalendarIcon',
    perfil_id: [5, 7],
  },
  {
    title: 'Cadastro Facial',
    route: 'NewFacial',
    icon: 'UserIcon',
    perfil_id: [5, 7],
  },
  {
    title: 'Cadastros',
    icon: 'FileTextIcon',
    perfil_id: [5, 7],
    children: [
      {
        title: 'Botões',
        route: 'list-botoes',
        perfil_id: [5, 7],
      },
      {
        title: 'CBO`s',
        route: 'list-cbos',
        perfil_id: [5, 7],
      },
      {
        title: 'Classificações de risco',
        route: 'list-classificacoes',
        perfil_id: [5, 7],
      },
      {
        title: 'Finalizações',
        route: 'list-finalizacoes',
        perfil_id: [5, 7],
      },
      {
        title: 'Linha de Cuidados',
        route: 'list-linha_cuidados',
        perfil_id: [5, 7],
      },
      {
        title: 'Locais',
        route: 'list-locais',
        perfil_id: [5, 7],
      },
      {
        title: 'Mensagens',
        route: 'list-mensagens',
        perfil_id: [5, 7],
      },
      {
        title: 'Motivos de Cancelamento',
        route: 'list-motivos',
        perfil_id: [5, 7],
      },
      {
        title: 'Paineis',
        route: 'list-paineis',
        perfil_id: [5, 7],
      },
      {
        title: 'Prioridades',
        route: 'list-prioridades',
        perfil_id: [5, 7],
      },
      {
        title: 'Setores',
        route: 'list-setores',
        perfil_id: [5, 7],
      },
      {
        title: 'Simbolos',
        route: 'list-simbolos',
        perfil_id: [5, 7],
      },
      {
        title: 'Questionário',
        route: 'list-questionario',
        perfil_id: [5, 7],
      },
      {
        title: 'Tipos de Gestão',
        route: 'list-tipo_gestoes',
        perfil_id: [5, 7],
      },
      {
        title: 'Tipos de Unidade',
        route: 'list-tipo_unidades',
        perfil_id: [5, 7],
      },
      {
        title: 'Totens',
        route: 'list-totens',
        perfil_id: [5, 7],
      },
      {
        title: 'Unidades',
        route: 'list-unidades',
        perfil_id: [5, 7],
      },
      {
        title: 'Usuários',
        route: 'list-users',
        perfil_id: [5, 7],
      },
      {
        title: 'Vídeos',
        route: 'list-videos',
        perfil_id: [5, 7],
      },
    ],
  },
  {
    title: 'Relatórios',
    icon: "PieChartIcon",
    perfil_id: [3, 4, 5, 7],
    children: [
      {
        title: "Acompanhar senhas",
        route: "list-acompanhamento",
        perfil_id: [3, 4, 5, 7],
      },
      {
        title: "Estatisticas",
        route: "list-estatisticas",
        perfil_id: [3, 4, 5, 7],
      },
      {
        title: "Indicadores",
        route: "indicadores",
        perfil_id: [3, 4, 5, 7],
      },
      {
        title: "Hist. Alteração de Nome",
        route: "historico-edicao-nome",
        perfil_id: [3, 4, 5, 7],
      },
      {
        title: "Ocupação da Unidade",
        route: "list-ocupacao",
        perfil_id: [5, 7],
      },
      {
        title: "Produtividade",
        route: "list-produtividade",
        perfil_id: [5, 7],
      },
      {
        title: "Senhas",
        route: "list-senhas",
        perfil_id: [2, 3, 4, 5, 7],
      },
      {
        title: "Previsão de Demanda",
        route: "previsao-demanda",
        perfil_id: [3, 4, 5, 7],
      },
      {
        title: "Previsão de Agendamentos",
        route: "previsao-agendamentos",
        perfil_id: [3, 4, 5, 7],
      },
    ]
  },
  {
    title: "Segurança",
    route: "list-panicos",
    icon: "LockIcon",
    perfil_id: [5, 6, 7],
  },
  {
    title: "Chamar senhas",
    route: "chamador",
    icon: "Volume2Icon",
    perfil_id: [1, 2, 3, 4, 5, 7],
  },
  {
    title: "Configurações",
    route: "list-configuracoes",
    icon: "SettingsIcon",
    perfil_id: [7],
  },
  {
    title: "Manuais",
    route: "list-manuais",
    icon: "BookIcon",
    perfil_id: [1, 2, 3, 4, 5, 6, 7],
  },
  // {
  //   title: "Logs",
  //   route: "list-logs",
  //   icon: "AlertTriangleIcon",
  //   perfil_id: [7],
  // },
  {
    title: "Fechamentos",
    route: "list-fechamento",
    icon: "ArchiveIcon",
    perfil_id: [7, 5, 4],
  },
  {
    title: 'Setar Setores',
    route: 'setar-setores',
    icon: 'TypeIcon',
    perfil_id: [5, 7],
  },
]